export const GRN_MODES = {
  PO: 'PO',
  DIRECT: 'DIRECT',
};

export const GRN_KINDS = [
  { value: 'STANDARD', label: 'Standard' },
  { value: 'DIRECT', label: 'Direct Receipt' },
  { value: 'RETURN', label: 'Return GRN' },
];

export const GRN_STEP_LABELS = {
  [GRN_MODES.PO]: [
    'Select PO', 'GRN Details', 'Add Items', 'QC Check', 'Create GRN', 'Post to Stock',
  ],
  [GRN_MODES.DIRECT]: [
    'Select Vendor', 'GRN Details', 'Add Items', 'QC Check', 'Create GRN', 'Post to Stock',
  ],
};

export const GRN_RECEIPT_MODE_OPTIONS = [
  {
    value: GRN_MODES.PO,
    title: 'Against Purchase Order',
    description: 'Receive goods linked to an approved, sent, or partially received PO. Add rows and pick items from the order.',
  },
  {
    value: GRN_MODES.DIRECT,
    title: 'Direct Receipt (No PO)',
    description: 'Record goods received without a purchase order. Add items, batches, and rates manually.',
  },
];

export const GRN_PAYMENT_TYPES = [
  { value: 'CREDIT', label: 'Credit' },
  { value: 'CASH', label: 'Cash' },
  { value: 'ADVANCE', label: 'Advance' },
];

/** Roles allowed to override PO tax / discount on GRN lines. */
export const GRN_PRICING_OVERRIDE_ROLES = [
  'admin',
  'facility admin',
  'inventory manager',
  'store_manager',
];

export const INDIAN_STATES = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
  'Andaman and Nicobar Islands',
  'Chandigarh',
  'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi',
  'Jammu and Kashmir',
  'Ladakh',
  'Lakshadweep',
  'Puducherry',
];
